import {
  PicklistDetails,
  PicklistLineDetails,
} from '@warebee/shared/engine-model';
import { MappingSchema } from '@warebee/shared/import-converter';
import {
  Field,
  GraphQLLocalDateTime,
  ID,
} from '@warebee/shared/util-backend-only-types';
import GraphQLJSON from 'graphql-type-json';

export type OrderLineId = [string, number];

export class PicklistLineAthena {
  // picklist
  @Field(() => ID)
  picklistId: string;

  @Field({ nullable: true })
  title?: string;

  @Field()
  pickingMethod: string;

  @Field(() => ID, { nullable: true })
  planeId?: string;

  @Field(() => [ID])
  agents: string[];

  @Field(() => [ID])
  orderIds: string[];

  @Field(() => ID, { nullable: true })
  unitOfWork?: string;

  @Field(() => ID, { nullable: true })
  pickingWaveId?: string;

  @Field(() => GraphQLLocalDateTime, { nullable: true })
  pickByDate?: string;

  @Field({ nullable: true })
  totalVolume?: number;

  @Field({ nullable: true })
  totalNetWeight?: number;

  @Field(() => ID, { nullable: true })
  orderLineRuleId?: string;

  @Field(() => ID, { nullable: true })
  picklistGroupKey?: string;

  @Field(() => PicklistDetails, { nullable: true })
  picklistDetails?: PicklistDetails;

  // picklist line
  /**
   * @TJS-type integer
   */
  @Field()
  picklistLine: number;

  @Field(() => ID)
  itemId: string;

  @Field(() => ID)
  locationId: string;

  @Field(() => ID)
  consignee: string;

  @Field(() => ID)
  sku: string;

  /**
   * @TJS-type integer
   */
  @Field()
  quantity: number;

  @Field({ nullable: true })
  uom?: string;

  /**
   * @TJS-type integer
   */
  @Field()
  uomQuantity: number;

  @Field({ nullable: true })
  volume?: number;

  @Field({ nullable: true })
  netWeight?: number;

  @Field(() => GraphQLJSON, { nullable: true })
  orderLines?: OrderLineId[];

  @Field(() => ID, { nullable: true })
  pickingRuleId?: string;

  @Field(() => ID, { nullable: true })
  pickingPriority?: string;

  @Field(() => PicklistLineDetails, { nullable: true })
  lineDetails?: PicklistLineDetails;
}

export const PICKLIST_LINE_SCHEMA: MappingSchema<PicklistLineAthena> = {
  fields: [
    {
      name: 'picklistId',
      type: 'string',
    },
    {
      name: 'title',
      type: 'string',
      optional: true,
    },
    {
      name: 'pickingMethod',
      type: 'string',
    },
    {
      name: 'planeId',
      type: 'string',
    },
    {
      name: 'agents',
      type: 'string',
    },
    {
      name: 'orderIds',
      type: 'string',
    },
    {
      name: 'unitOfWork',
      type: 'string',
      optional: true,
    },
    {
      name: 'pickingWaveId',
      type: 'string',
      optional: true,
    },
    {
      name: 'pickByDate',
      type: 'localDateTime',
      optional: true,
    },
    {
      name: 'totalVolume',
      type: 'number',
      optional: true,
    },
    {
      name: 'totalNetWeight',
      type: 'number',
      optional: true,
    },
    {
      name: 'orderLineRuleId',
      type: 'string',
      optional: true,
    },
    {
      name: 'picklistGroupKey',
      type: 'string',
      optional: true,
    },
    {
      name: 'picklistDetails',
      type: 'string',
      optional: true,
    },
    { name: 'picklistLine', type: 'integer' },
    { name: 'itemId', type: 'string' },
    { name: 'locationId', type: 'string' },
    { name: 'consignee', type: 'string' },
    { name: 'sku', type: 'string' },
    { name: 'quantity', type: 'integer' },
    { name: 'uom', type: 'string', optional: true },
    { name: 'uomQuantity', type: 'integer' },
    { name: 'volume', type: 'number', optional: true },
    { name: 'netWeight', type: 'number', optional: true },
    { name: 'orderLines', type: 'string', optional: true },
    { name: 'pickingRuleId', type: 'string', optional: true },
    { name: 'pickingPriority', type: 'string', optional: true },
    { name: 'lineDetails', type: 'string', optional: true },
  ],
};
